function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.464.45h4.072l5.391 15.1H11.76l-.821-2.3H6.062l-.822 2.3H1.072L6.464.45zm.775 1.1l-4.606 12.9h1.832l.821-2.3h6.427l.821 2.3h1.832L9.76 1.55H7.24zm.718 3.119h1.085l2.028 5.681H5.93l2.028-5.681zM8.5 6.422L7.49 9.25h2.02L8.5 6.422z",
  fill: "currentColor"
});

function SvgFont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjQ2Mzc3IDAuNDUwMTk1SDEwLjUzNTdMMTUuOTI3MSAxNS41NTAySDExLjc1OTFMMTAuOTM3OCAxMy4yNUg2LjA2MTU3TDUuMjQwMjggMTUuNTUwMkgxLjA3MjI3TDYuNDYzNzcgMC40NTAxOTVaTTcuMjM5MDMgMS41NTAyTDIuNjMzMDQgMTQuNDUwMkg0LjQ2NTAyTDUuMjg2MzIgMTIuMTVIMTEuNzEzMUwxMi41MzQ0IDE0LjQ1MDJIMTQuMzY2NEw5Ljc2MDQgMS41NTAySDcuMjM5MDNaTTcuOTU3NDYgNC42Njg5NUg5LjA0MTkyTDExLjA3MDQgMTAuMzVINS45MjkwMUw3Ljk1NzQ2IDQuNjY4OTVaTTguNDk5NjkgNi40MjE1OEw3LjQ4OTc5IDkuMjVIOS41MDk1OUw4LjQ5OTY5IDYuNDIxNThaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgFont as ReactComponent };